import React, { useEffect, useState } from "react";
import { Alert, CircularProgress, FormControlLabel, Switch, Typography } from "@mui/material";
import API from "../API";

export default function JyskOrderAvailabilityScreen() {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(null);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    API.panelFetch("jyskorderavailability", {}).then((response) => {
      if (!active) return;
      if (response?.ok) setStores(response.stores);
      else setError(response?.message || "Ayarlar yüklenemedi.");
    }).catch(() => { if (active) setError("Ayarlar yüklenemedi."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);
  const save = async (userId, enabled) => {
    setSaving(userId);
    setSuccess("");
    setError("");
    try {
      const response = await API.panelFetch("jyskorderavailability", { action: "save", userId, enabled });
      if (response?.ok) {
        setStores(response.stores);
        setSuccess("Mağaza ayarı kaydedildi.");
      }
      else setError(response?.message || "Ayar kaydedilemedi.");
    } catch { setError("Ayar kaydedilemedi."); }
    finally { setSaving(null); }
  };
  return <div style={{ padding: 28 }}>
    <Typography variant="h4">JYSK Mağaza Sipariş Seçenekleri</Typography>
    <Typography sx={{ my: 2 }}>Her mağaza hesabı için Hemen ve Planlı siparişleri açın veya kapatın. Varsayılan: Açık. Esnek siparişler etkilenmez.</Typography>
    {error && <Alert severity="error">{error}</Alert>}
    {success && <Alert severity="success" role="status">{success}</Alert>}
    {loading ? <CircularProgress /> : stores.map((store) => <div key={store._id} style={{ padding: 12, borderBottom: "1px solid #ddd" }}>
      <FormControlLabel label={`${store.name} — Hemen / Planlı: ${store.nowScheduledOrdersEnabled !== false ? "Açık" : "Kapalı"}`}
        control={<Switch checked={store.nowScheduledOrdersEnabled !== false} disabled={saving !== null}
          onChange={(_, enabled) => save(store._id, enabled)} />} />
      {saving === store._id && <CircularProgress size={18} aria-label="Kaydediliyor" />}
    </div>)}
  </div>;
}
